import axios from "~/plugins/axios";

export default {
  getConnectors() {
    return axios.get("web_api/mail/connectors").then((response) => response.data);
  },
  getMailboxes() {
    return axios.get("/web_api/mail/mailboxes").then((response) => response.data);
  },
  getMailboxesByConnectorSettingId(connectorSettingId) {
    return axios.get(`/web_api/mail/connectors/${connectorSettingId}/mailboxes`).then((response) => response.data);
  },
  updateConnectorSetting(connectorSetting) {
    return axios.put(`/web_api/mail/connectors/${connectorSetting.id}`, connectorSetting).then((response) => response.data);
  },
  deleteConnectorSetting(connectorSetting) {
    return axios.delete(`/web_api/mail/connectors/${connectorSetting.id}`).then((response) => response.data);
  },
  updateMailbox(mailbox) {
    return axios.put(`/web_api/mail/mailboxes/${mailbox.id}`, mailbox).then((response) => response.data);
  },
};
